import { off, on, postEvent } from '@telegram-apps/sdk';
import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isTelegramMiniApp } from '../../utils/telegram';

export const useTelegramBackButton = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Обработчик клика
    const onBackButtonClick = useCallback(() => {
        console.log('back button pressed');
        navigate(-1);
    }, [navigate]);

    useEffect(() => {
        if (process.env.NODE_ENV !== 'development' && isTelegramMiniApp()) {
            const isVisible = location.pathname !== "/dashboard";
            postEvent('web_app_setup_back_button', { is_visible: isVisible });
            on('back_button_pressed', onBackButtonClick);

            return () => {
                off('back_button_pressed', onBackButtonClick);
            };
        }
    }, [location, onBackButtonClick]);
};